import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesCustomControlForm } from './FormSamplesCustomControlForm';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { FormSamplesCustomControlPageInfo } from './FormSamplesCustomControlPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
  playerChoice: string;
}

export const FormSamplesCustomControlPage = () => {

  const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: ExampleDto) => {
    setSubmitting(true);
    setSubmittedValues(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer
      heading='Form Samples - Custom Control'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesCustomControlPageInfo />}
    >
      <PageDefaultSegment width={500}>
        <FormSamplesCustomControlForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={500} submittedValues={submittedValues} />
    </PageContainer>
  )
}
